import Model from './Model'
import CustomerFeedback from './CustomerFeedback'
import CustomerNotification from './CustomerNotification'
export default class Customer extends Model {

    resource()
    {
        return 'customers'
    }

    feedbacks() {
        return this.hasMany(CustomerFeedback)
    }

    notifications() {
        return this.hasMany(CustomerNotification)
    }
}
